import * as Yup from 'yup';

export const validationSchema = (T) => Yup.object().shape({ name: Yup.string().required(T.required_field).trim() });
